export default __webpack_public_path__ + "static/media/128x128.f94221c8.jpg";